import { FormControlProps, FormElementControlPropsType } from 'components/common/form/layout/control';
import { FormComponentBuilder } from 'components/common/form/layout';
import GenericWorkflow from './index';

export interface FormGenericWorkflowProps extends FormControlProps {
    wrapWithContainer: boolean;
}

export default function FormGenericWorkflow({
    controlProps,
    elementProps,
}: FormElementControlPropsType<FormGenericWorkflowProps>) {
    return <GenericWorkflow />;
}

export class FormGenericWorkflowBuilder extends FormComponentBuilder {
    prepareProps(): FormGenericWorkflowProps {
        return {
            ...this.controlProps,
            wrapWithContainer: false,
        };
    }
}
